module.exports = {
  BASE_URL: "https://api.trade.gov",
  ACCESS_TOKEN: "b0045391-2ef8-3049-a215-f78b7716f045",
}
